import React from 'react';
import PropTypes from 'prop-types';

function ChannelDetail({ data }) {
  return (
    <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-3">
      <div className="sm:col-span-1">
        <dt className="text-sm font-medium text-gray-500">Code</dt>
        <dd className="mt-1 text-sm text-gray-900">{data.code}</dd>
      </div>

      <div className="sm:col-span-1">
        <dt className="text-sm font-medium text-gray-500">Category</dt>
        <dd className="mt-1 text-sm text-gray-900">{data.category}</dd>
      </div>

      <div className="sm:col-span-1">
        <dt className="text-sm font-medium text-gray-500">Fee</dt>
        <dd className="mt-1 text-sm text-gray-900">{data.fee}</dd>
      </div>

      <div className="sm:col-span-3">
        <dt className="text-sm font-medium text-gray-500">Address</dt>
        <dd className="mt-1 text-sm text-gray-900">{data.address}</dd>
      </div>
    </dl>
  );
}

ChannelDetail.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
};

export default ChannelDetail;
